import { Injectable } from '@angular/core';
import { LayoutService } from '@services/layout/layout.service';
import Swal from 'sweetalert2';

@Injectable()
export class SweetAlertsService {
	constructor(public layoutService: LayoutService) {}

	show(icon: any, title: string, text: string) {
		if (this.layoutService.config.colorScheme === 'dark') {
			Swal.fire({
				icon: icon,
				title: title,
				text: text,
				background: '#323130',
				color: '#fff',
				confirmButtonColor: '#3a3a3a',
				cancelButtonColor: '#3a3a3a',
			});
		} else {
			Swal.fire({
				icon: icon,
				title: title,
				text: text,
			});
		}
	}
}
